<script>
import defaultPopupImage from "@/gallery/popup/popupimage/popupimage.vue";

export default {
  extends: defaultPopupImage,
};
</script>

<style scoped lang="scss">
$lassiePrimaryColor: #002354;

.frisbuy-popup-image {
  .frisbuy-marker-area {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;

    .frisbuy-marker {
      border-color: $lassiePrimaryColor;
      color: $lassiePrimaryColor;

      &.frisbuy-marker-hover {
        background-color: $lassiePrimaryColor;
        color: #ffffff;
      }
    }
  }
}
</style>

<!-- TODO: refactor scoped styles to avoid copying them -->
<!-- default styles -->
<style scoped lang="scss">
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.frisbuy-popup-image {
  width: 100%;
  height: 100%;
  position: relative;

  overflow: hidden;

  //&.frisbuy-provider-vk {
  //  &:before {
  //    bottom: auto;
  //    top: 10px;
  //  }
  //}
  //&.frisbuy-provider-tiktok {
  //  &:before {
  //    bottom: auto;
  //    top: 10px;
  //  }
  //}
  //&.frisbuy-provider-instagram {
  //  &:before {
  //    bottom: auto;
  //    top: 10px;
  //  }
  //}
  //&.frisbuy-provider-frisbuy {
  //  &:before {
  //    bottom: auto;
  //    top: 10px;
  //  }
  //}

  &.frisbuy-full-size > div:first-child div {
    background-size: cover;
    display: block;
  }

  .frisbuy-image-area {
    padding-bottom: 100%;

    img {
      display: block;
      position: relative;
      visibility: hidden;
    }

    div {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: 50% 50%;
    }
  }
}
</style>
